import { useQuota } from "../../hooks/useQuota";

export function QuotaBar() {
  const { percent, usedStr, quotaStr } = useQuota();

  const barColor =
    percent >= 90
      ? "bg-red-500"
      : percent >= 75
      ? "bg-yellow-500"
      : "bg-brand-500";

  return (
    <div className="px-4 py-3">
      <div className="mb-1 flex justify-between text-xs text-gray-400">
        <span>{usedStr} used</span>
        <span>{quotaStr}</span>
      </div>
      <div className="h-1.5 w-full rounded-full bg-gray-700">
        <div
          className={`h-full rounded-full transition-all ${barColor}`}
          style={{ width: `${Math.min(percent, 100)}%` }}
        />
      </div>
      <p className="mt-1 text-xs text-gray-500">{percent}% used</p>
    </div>
  );
}
